<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
    height="200px"
    @keydown.esc="chiudiDialog()"
    persistent
  >
    <v-card>
      <v-card-title class="ma-0 pa-0">
        <v-toolbar dense text :color="colore" dark>
          File
          <v-spacer> </v-spacer>
          <v-btn icon @click="chiudiDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-col>
        <v-row v-for="(item, i) in elencoFile" :key="i" class="ma-2">
          <span>
            <v-icon v-if="immagine(item.Tipo)">image</v-icon>
            <v-icon v-else>description</v-icon>
          </span>
          <span
            @click="visualizzaFile(item.Percorso, item.Tipo)"
            style="cursor: pointer"
          >
            {{ item.Nome }}
          </span>
        </v-row>
      </v-col>
    </v-card>

    <!-- anteprima dell'immagine, se la clicco apre l'immagine in una nuova scheda -->
    <v-dialog
      v-model="dialogImg"
      max-width="500px"
      max-height="600px"
      @keydown.esc="
        dialogImg = false;
        dialogFile = true;
      "
    >
      <!-- sull'esc imposto la dialogFile=true altrimenti me la chiude insieme all'immagine -->
      <v-img
        class="ma-0 pa-0"
        max-width="500px"
        max-height="600px"
        :src="imgSelected"
        :contain="true"
        style="cursor: pointer"
        v-on:click="apriDocumento(imgSelected)"
      >
      </v-img>
    </v-dialog>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: { type: Boolean, default: false },
    elencoFile: { type: Array, required: true },
    colore: { type: String, default: "primary" },
  },

  data: () => ({
    dialogImg: false,
    imgSelected: "",
  }),

  methods: {
    chiudiDialog() {
      this.$emit("chiudi");
    },

    immagine(tipo) {
      let tp = tipo.toLowerCase();
      return tp == "jpg" || tp == "jpeg" || tp == "png";
    },

    visualizzaFile(percorso, tipo) {
      if (!this.immagine(tipo)) {
        this.apriDocumento(percorso);
        return;
      }
      this.imgSelected = percorso;
      this.dialogImg = true;
    },

    apriDocumento(file) {
      window.open(file, "_blank");
    },
  },
};
</script>
